import type { NavigationGuard } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

export const redirectToProfileIfNotAdmin: NavigationGuard = () => {
  if (useAuthStore().isUserAdmin) {
    return true;
  } else {
    return { name: 'settings-account-profile' };
  }
};

export const redirectToProfileIfNotAdminOrTeamlead: NavigationGuard = () => {
  if (useAuthStore().isUserAdmin || useAuthStore().isUserTeamlead) {
    return true;
  } else {
    return { name: 'settings-account-profile' };
  }
};

export const redirectToProfileIfNoAccess = (
  permission: keyof ReturnType<typeof useAuthStore>['appAccess']['settings']['company']
): NavigationGuard => {
  return () => {
    const authStore = useAuthStore();
    if (authStore.appAccess.settings.company[permission]) {
      return true;
    } else {
      return { name: 'settings-account-profile' };
    }
  };
};
